import { FC } from 'react'
import { CustomInput, FormGroup, Label } from 'reactstrap'

import { translate } from '../../../../helpers/translations/translator'
import { AppFilter } from '../../../../redux/filter-ts/filterModels'
import FilterBlock from '../FilterBlock/FilterBlock'


interface FilterProps {
    filter: AppFilter;
    onChange: (filter: AppFilter) => void;
}

const DeniedLeaveOfAbsenceRequestsFilter: FC<FilterProps> = ({ filter, onChange }) => {
    const onCheckboxChange = (showDenied: boolean) => {
        const absences = {
            ...filter.absences,
            showDenied,
        }

        onChange({
            ...filter,
            absences,
        })
    }

    return (
        <FilterBlock title={translate('pages.absences.leaveOfAbsenceRequests')}>
            <FormGroup check className="p-0">
                <Label check>
                    <CustomInput
                        id="show-denied-leave-of-absences-request-filter-checkbox"
                        type="checkbox"
                        label={translate('pages.absences.showDenied')}
                        checked={filter.absences.showDenied}
                        onChange={() => onCheckboxChange(! filter.absences.showDenied)}
                    />
                </Label>
            </FormGroup>
        </FilterBlock>
    )
}

export default DeniedLeaveOfAbsenceRequestsFilter
